import { render, staticRenderFns } from "./productionIssue-add-or-update.vue?vue&type=template&id=24634deb&scoped=true"
import script from "./productionIssue-add-or-update.vue?vue&type=script&lang=js"
export * from "./productionIssue-add-or-update.vue?vue&type=script&lang=js"
import style0 from "./productionIssue-add-or-update.vue?vue&type=style&index=0&id=24634deb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24634deb",
  null
  
)

export default component.exports